import { h } from 'preact'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonLoader = ({ count = 5 }) => (
  <div className="skeleton-loader">
    <Skeleton count={count} />
  </div>
)

SkeletonLoader.propTypes = {
  count: PropTypes.number,
}

export default SkeletonLoader
